import React, { Component } from 'react';

import { FaWrench } from 'react-icons/fa';

import './BuildingPage.scss';

export class BuildingPage extends Component {
    render() {
        return <div className='BuildingPage'>
            <p><FaWrench size={42} /></p>
            <h1>Em construção</h1>
        </div>
    }
}